/** Promo banners in rotation order: sample cabinet → delivery → panel → drawing. */
export const CATALOG_PROMO_BANNER_COUNT = 4;

/** Index 0 (sample cabinet) — also rendered once at the top before the product list. */
export const CATALOG_PROMO_TOP_BANNER_INDEX = 0;

/** Show a banner after every N products (N, 2N, 3N… in catalog display order). */
export const CATALOG_PROMO_BANNER_EVERY_N_PRODUCTS = 3;

export function shouldShowCatalogPromoBannerAfterProduct(ordinal) {
  const n = CATALOG_PROMO_BANNER_EVERY_N_PRODUCTS;
  return ordinal > 0 && ordinal % n === 0;
}

/**
 * Inline slots after products 3, 6, 9, 12… use banners 1, 2, 3, 0, 1…
 * (top already shows banner 0; list continues with banner 1 after the 3rd product).
 */
export function catalogPromoBannerIndexAfterProduct(ordinal) {
  const slot =
    Math.floor(ordinal / CATALOG_PROMO_BANNER_EVERY_N_PRODUCTS) - 1;
  return (slot + 1) % CATALOG_PROMO_BANNER_COUNT;
}
